module.exports = __webpack_public_path__ + "assets/img/bmy.15ccd384.png";